import * as React from 'react';

import Vrachtauto from '@hvcgroep/design-system/assets/illustrations/Overgang-niet-zonder-energie.svg';
import Wereldbol from '@hvcgroep/design-system/assets/illustrations/Wereldbol.svg';
import Werkzaamheden from '@hvcgroep/design-system/assets/illustrations/Werkzaamheden.svg';
import Kantoor from '@hvcgroep/design-system/assets/illustrations/HVC-kantoor.svg';
import Afvalwijzer from '@hvcgroep/design-system/assets/illustrations/Afvalwijzer.svg';

type Props = {
  label: string;
  className: string;
};

const Illustration = (props: Props) => {
  const { label, className } = props;

  if (label.toLowerCase().includes('transport')) {
    return <img className={className} src={Vrachtauto} alt="Illustratie van een vrachtauto" />;
  }

  if (label.toLowerCase().includes('projecten')) {
    return <img className={className} src={Wereldbol} alt="Illustratie van een wereldbol" />;
  }

  if (label.toLowerCase().includes('kantoor')) {
    return <img className={className} src={Kantoor} alt="Illustratie van een kantoor" />;
  }

  if (label.toLowerCase().includes('technische')) {
    return <img className={className} src={Werkzaamheden} alt="Illustratie van gereedschappen" />;
  }

  return <img className={className} src={Afvalwijzer} alt="Illustratie van een wegwijzer" />;
};

export default Illustration;
